"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useClassBuilder = _interopRequireDefault(require("../../hooks/useClassBuilder"));

var _useStyleBuilder = _interopRequireDefault(require("../../hooks/useStyleBuilder"));

var _toast = _interopRequireDefault(require("./toast"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*---------------------------------------------*/
var BASE_CLASS = "lth-c-toaster";
var MSG_ADD = "toaster::add";
var TOAST_DURATION = 5000;
/*---------------------------------------------*/

function Toaster(props) {
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var itemsRef = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    window.addEventListener("message", onMessage);
    return function () {
      return window.removeEventListener("message", onMessage);
    };
  }, []);
  var customClasses = [];

  if (props.position) {
    customClasses.push(BASE_CLASS + "--position-" + props.position);
  }

  var classes = (0, _useClassBuilder.default)(props, BASE_CLASS, customClasses);
  var style = (0, _useStyleBuilder.default)(props);
  var content = items.sort(function (a, b) {
    return a.timestamp - b.timestamp;
  }).map(function (item, _index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: BASE_CLASS + '__item animate-in',
      key: item.id,
      ref: function ref(el) {
        return itemsRef.current[item.id] = el;
      }
    }, /*#__PURE__*/_react.default.createElement(_toast.default, {
      id: item.id,
      title: item.title,
      content: item.content,
      icon: item.icon,
      variant: item.type,
      onClose: function onClose() {
        return removeItem(item.id);
      }
    }));
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, content);
  /*------------------------------------------*/

  function onMessage(msg) {
    var event = msg.data;

    if (event.type !== MSG_ADD) {
      return;
    } // if both are undefined - that's fine


    if (event.target !== props.id) {
      return;
    }

    var item = event.item;
    addItem(item);
  }

  function addItem(item) {
    item.id = item.id || Math.random().toString().slice(2);
    item.timestamp = 1 * new Date();
    setItems(function (items) {
      return [].concat(_toConsumableArray(items), [item]);
    });

    (function (itemId) {
      setTimeout(function () {
        return removeItem(itemId);
      }, item.duration || TOAST_DURATION);
    })(item.id);
  }

  function removeItem(id) {
    if (!itemsRef.current[id]) {
      return;
    }

    itemsRef.current[id].classList.remove("animate-in");
    itemsRef.current[id].classList.add("animate-out");
    setTimeout(function () {
      setItems(function (items) {
        return items.filter(function (item) {
          return item.id !== id;
        });
      });
      delete itemsRef.current[id];
    }, 1000);
  }
}
/*---------------------------------------------*/


Toaster.add = function (item, target) {
  window.postMessage({
    type: MSG_ADD,
    target: target,
    item: item
  });
};
/*---------------------------------------------*/


var _default = Toaster;
/*---------------------------------------------*/

exports.default = _default;
Toaster.METADATA = {
  name: 'Toaster',
  props: [{
    name: "Add Toast",
    type: "button",
    action: function action() {
      return Toaster.add("Test");
    }
  }],
  content: {}
};